import { render, staticRenderFns } from "./BoxNode.vue?vue&type=template&id=9c5e4664&scoped=true&"
import script from "./BoxNode.vue?vue&type=script&lang=js&"
export * from "./BoxNode.vue?vue&type=script&lang=js&"
import style0 from "./BoxNode.vue?vue&type=style&index=0&id=9c5e4664&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5e4664",
  null
  
)

export default component.exports